import entityList from './view/entityList.vue'
import compositeList from './view/compositeList.vue'

import listMixin from '../mixins/listMixin'

// export const qt = (key) => {


export default {
    entityList,
    compositeList, 
    
    listMixin
};
